@if (!autoLoginInProgress) {
<div class="login-page">
  <div class="login-shell">
    <!-- Left Visual Panel -->
    <div class="login-visual">
      <div class="visual-content">
        <!-- <div class="visual-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div> -->
        <div class="visual-image">
          <img
            src="assets/images/absences_lms_login_banner.svg"
            alt="Workforce management"
          />
        </div>
        <div class="visual-footer">
          <span>
            <i class="pi pi-shield"></i>
            Secure &amp; reliable
          </span>
          <span>
            <i class="pi pi-sparkles"></i>
            AI-powered Absence Law Assistance
          </span>
          <span>
            <i class="pi pi-sparkles"></i>
            Intelligent AI agent
          </span>
        </div>
      </div>
    </div>
    <!-- Right Login Panel -->
    <div class="login-panel">
      <div class="login-content">
        <!-- Mobile Logo -->
        <div class="mobile-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div>
        <div class="login-header">
          <!-- <span class="login-eyebrow"> Welcome back </span> -->
          <h2>Sign in to your account</h2>
          <p>Enter your credentials to continue.</p>
        </div>
        <!-- Error -->
        @if (loginErrMsg) {
        <div class="login-alert" role="alert">
          <div class="alert-icon">
            <i class="pi pi-exclamation-circle"></i>
          </div>
          <div class="alert-content">
            <span>{{ loginErrMsg }}</span>
          </div>
          <button
            type="button"
            class="alert-close"
            (click)="removeErrMsg()"
            aria-label="Close notification"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
        }
        <form [formGroup]="loginForm" class="login-form">
          <!-- Email -->
          <div class="form-field">
            <label for="email"> Email address </label>
            <div class="input-wrapper">
              <i class="pi pi-envelope input-icon"></i>
              <input
                id="email"
                pInputText
                class="form-input"
                type="email"
                placeholder="name@company.com"
                autocomplete="email"
                formControlName="email_id"
              />
            </div>
            <form-validation [control]="loginForm.controls.email_id">
            </form-validation>
          </div>
          <!-- Continue -->
          @if (!isloginBtnShow && !showSpinner) {
          <button
            type="button"
            class="login-button"
            (click)="authenticateEmailVerify(loginForm.value)"
            [disabled]="loginForm.invalid"
          >
            <span>Continue</span>
            <i class="pi pi-arrow-right"></i>
          </button>
          }
          <!-- Email Loading -->
          @if (showSpinner) {
          <button type="button" class="login-button loading" disabled>
            <span class="spinner-border"></span>
            <span>Checking...</span>
          </button>
          }
          <!-- Password Section -->
          @if (isloginBtnShow) {
          <div class="form-field password-field">
            <div class="field-header">
              <label for="password"> Password </label>
              <a class="forgot-link" (click)="redirectToforgetpass()">
                Forgot password?
              </a>
            </div>
            <div class="input-wrapper">
              <i class="pi pi-lock input-icon"></i>
              <input
                id="password"
                class="form-input password-input"
                [type]="show ? 'text' : 'password'"
                placeholder="Enter your password"
                autocomplete="current-password"
                formControlName="password"
              />
              <button
                type="button"
                class="password-toggle"
                (click)="showHidePassword()"
                aria-label="Toggle password visibility"
              >
                <i
                  class="pi"
                  [ngClass]="{
                    'pi-eye-slash': !show,
                    'pi-eye': show
                  }"
                ></i>
              </button>
            </div>
            <form-validation [control]="loginForm.controls.password">
            </form-validation>
          </div>
          <!-- Login -->
          @if (!showBtnSpinner) {
          <button
            type="button"
            class="login-button"
            (click)="authenticateUser(loginForm.value)"
            [disabled]="loginForm.invalid"
          >
            <span>Sign in</span>
            <i class="pi pi-arrow-right"></i>
          </button>
          }
          <!-- Login Loading -->
          @if (showBtnSpinner) {
          <button type="button" class="login-button loading" disabled>
            <span class="spinner-border"></span>
            <span>Signing in...</span>
          </button>
          } }
          <!-- Signup -->
          <div class="signup-section">
            <span>Don't have an account?</span>
            <a (click)="redirectTosignup()" class="signup-link">
              Create an account
            </a>
          </div>
        </form>
        <!-- <div class="login-security">
          <i class="pi pi-lock"></i>
          <span>Your information is protected and securely encrypted.</span>
        </div> -->
      </div>
    </div>
  </div>
</div>
}

<!-- Auto Login -->
@if (autoLoginInProgress) {
<div class="auto-login">
  <div class="auto-login-card">
    <div class="animation-wrapper">
      <canvas #dotCanvas id="dotlottie-canvas"></canvas>
    </div>
    <h4>Signing you in</h4>
    <p>Please wait while we securely log you in...</p>
    <div class="progress-line">
      <span></span>
    </div>
  </div>
</div>
}
